"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
// Relements
var box_1 = __importDefault(require("relements/build/esm/ui/box"));
var button_1 = __importDefault(require("relements/build/esm/ui/button"));
var buttonStyles = function (props) {
    var theme = props.theme, type = props.type, disabled = props.disabled, trainButton = props.trainButton, blink = props.blink;
    var isDisabled = disabled || type === 'graph';
    return __assign(__assign({ display: 'flex', justifyContent: 'center', boxShadow: !isDisabled && 'none !important', border: type === 'graph'
            ? "1px solid " + (isDisabled ? theme.colors.grey.haptik : theme.colors.blue.haptik) + "!important"
            : '1px solid transparent', background: theme.colors.grey.pastel + "!important", width: type === 'icon' ? 36 : 'auto', fontSize: 16, margin: 0, padding: type === 'graph' ? 6 : '5px 6px', color: isDisabled ? theme.colors.grey.dark : theme.colors.black.haptik, path: {
            fill: isDisabled ? theme.colors.grey.dark : theme.colors.black.haptik,
        }, svg: {
            cursor: disabled ? 'not-allowed' : 'pointer',
        }, position: 'relative' }, (type !== 'graph' &&
        type !== 'icon' &&
        !isDisabled && {
        '&:hover': {
            boxShadow: 'none !important',
            backgroundColor: theme.colors.blue.pastel + "80 !important",
            borderRadius: theme.radii.xs,
            color: theme.colors.blue.haptik,
            path: {
                fill: theme.colors.blue.haptik,
            },
        },
    })), { '&::before': {
            content: '""',
            position: 'absolute',
            display: trainButton && blink ? 'block' : 'none',
            top: 9,
            left: 9,
            width: 15,
            height: 15,
            backgroundColor: theme.colors.black.haptik,
            borderRadius: '50%',
        }, '&:hover::before': {
            backgroundColor: theme.colors.blue.haptik,
        }, '> div': {
            width: type === 'graph' ? 24 : 'auto',
            height: type === 'graph' ? 24 : 'auto',
        } });
};
var pulse = styled_components_1.keyframes(templateObject_1 || (templateObject_1 = __makeTemplateObject(["0% {\n  transform: scale3d(0, 0, 0);\n  opacity: 1;\n}\n20% {\n  transform: scale3d(1.5, 1.5, 1);\n  opacity: 0;\n}\n100% {\n  transform: scale3d(1.5, 1.5, 1);\n  opacity: 0;\n}"], ["0% {\n  transform: scale3d(0, 0, 0);\n  opacity: 1;\n}\n20% {\n  transform: scale3d(1.5, 1.5, 1);\n  opacity: 0;\n}\n100% {\n  transform: scale3d(1.5, 1.5, 1);\n  opacity: 0;\n}"])));
var animation = function () {
    return styled_components_1.css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    &::before {\n      animation: ", " 2s ease-out infinite;\n      animation-delay: 0.2s;\n    }\n  "], ["\n    &::before {\n      animation: ", " 2s ease-out infinite;\n      animation-delay: 0.2s;\n    }\n  "])), pulse);
};
var GButton = styled_components_1["default"](button_1["default"])(buttonStyles, animation);
var GraphButton = function (_a) {
    var children = _a.children, onClick = _a.onClick, disabled = _a.disabled, type = _a.type, blink = _a.blink, trainButton = _a.trainButton, secondaryIcon = _a.secondaryIcon, onSecondaryIconClick = _a.onSecondaryIconClick, ref = _a.ref, id = _a.id;
    return (react_1["default"].createElement(GButton, { themed: true, variant: disabled ? 'disabled' : 'secondary', onClick: onClick, type: type, disabled: disabled, secondaryIcon: secondaryIcon, onSecondaryIconClick: onSecondaryIconClick, blink: blink, trainButton: trainButton, ref: ref, id: id }, type === 'graph' ? (children) : (react_1["default"].createElement(box_1["default"], { padding: "zero", alignItems: "center", style: {
            columnGap: 8,
            background: 'transparent',
        } }, children))));
};
exports["default"] = GraphButton;
var templateObject_1, templateObject_2;
